import {
  Component,
  OnInit,
  HostListener,
  ChangeDetectorRef,
  AfterViewInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { SIGNUP_HEADERS } from '@shared/constants/signup-headers';
import { StepsService } from '@shared/services/steps/steps.service';
import { PreOrderDetailsService } from '@shared/api/steps/pre-order-details/pre-order-details.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PanelOptionsService } from '@shared/services/pre-order/panel-options/panel-options.service';
import { SessionStorageService } from '@shared/services/session-storage/session-storage.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { PrivacyPolicyComponent } from '@shared/components/modals/privacy-policy/privacy-policy.component';
import { PreOrderService } from '@modules/pre-order/api/pre-order/pre-order.service';
import { CurrentUserService, UrlQueryStringService } from '@shared/services';
import { ViewportService } from '@shared/services/viewport/viewport.service';

@Component({
  selector: 'pre-order-details',
  templateUrl: './pre-order-details.component.html',
  styleUrls: ['./pre-order-details.component.scss']
})
export class PreOrderDetailsComponent implements OnInit, AfterViewInit {
  isDesktop;
  isTablet;
  isMobile;
  isOrderConfirm: boolean = false;
  isValidPanelOption = false;
  termsAndConditionChecked = false;
  propertyId;
  paymentMethodOptions;
  modalRef: BsModalRef;
  modalConfig = {
    ignoreBackdropClick: true,
    class: 'modal-sm'
  };
  modalDetails;
  dashboardUrl;
  moduleName;
  isPreOrder;
  hideBackBtn = false;
  @ViewChild('preOrderConfirmModal')
  tempRefPreOrderConfirm: TemplateRef<any>;

  @ViewChild('privacyPolicyModal')
  tempRefPrivacyPolicy: TemplateRef<any>;

  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this._viewportService.checkViewSizes();
    }, 250);
  }

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private _stepsService: StepsService,
    private _stepPreOrderDetailsService: PreOrderDetailsService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private _panelOptionsService: PanelOptionsService,
    private _sessionStorageService: SessionStorageService,
    private modalService: BsModalService,
    private _currentUser: CurrentUserService,
    private _preOrderService: PreOrderService,
    private _urlQueryStringService: UrlQueryStringService,
    private _viewportService: ViewportService
  ) {
    this.getPaymentMethods();
    this._viewportService.updatingView.subscribe(() => {
      this.isDesktop = this._viewportService.isDesktop();
      this.isTablet = this._viewportService.isTablet();
      this.isMobile = this._viewportService.isMobile();
      if (this._stepsService.getCurrentStep() === 2) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  ngOnInit() {
    this.propertyId =
      this.activatedRoute.snapshot.params.hasOwnProperty('id') &&
      this.activatedRoute.snapshot.params.id;

    this.moduleName = this._stepsService.getModuleName();
    if (!this.moduleName) {
      this.router.navigate(['/app/properties']);
    }
    this.isPreOrder = this._stepsService.isCurrentModulePreOrder(
      this.moduleName
    );

    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const currentStepId = this._stepsService.getSession('step_id');
    this.hideBackBtn = currentStepId === 2 && currentUser;
    this.dashboardUrl = '/dashboard';
  }

  ngAfterViewInit() {
    this._viewportService.checkViewSizes();
  }

  confirmOrder() {
    if (!this.isOrderConfirm) {
      this.isOrderConfirm = true;
      const params = {
        propertyId: this.propertyId,
        paymentMethodId: this._panelOptionsService.getSelectedMethodId(),
        noOfParts: this._panelOptionsService.getSelectedNumberOfParts(),
        userName: this._sessionStorageService.getSession('username'),
        promoCode: this._urlQueryStringService.getPromoDiscount()
      };
      this.setPreOrder(params);
    }
  }

  back() {
    this._stepsService.setHeaderTexts(SIGNUP_HEADERS.CONTACT_INFORMATION);
    this._stepsService.setDoneSteps([0]);
    this._stepsService.setTransitionDirection('LEFT');
    this._stepsService.setCurrentStep(1);
  }

  setPreOrder(params) {
    return this._stepPreOrderDetailsService
      .setPreOrder(this.propertyId, params)
      .subscribe(res => {
        this.modalDetails = res;
        const { username } = JSON.parse(localStorage.getItem('currentUser'));
        const obj = {
          isLogin: true,
          username
        };
        localStorage.setItem('currentUser', JSON.stringify(obj));
        this._currentUser.loanUserInfo();
        this._preOrderService
          .setPreOrderStep(this._stepsService.getSession('username'), 3)
          .subscribe(() => {
            this._stepsService.setSession('step_id', 3);
            this.showPreOrderConfirmModal(this.tempRefPreOrderConfirm);
            this.isOrderConfirm = false;
          });
      });
  }

  getPaymentMethods() {
    this._stepPreOrderDetailsService.getPaymentMethods().subscribe(res => {
      this.paymentMethodOptions = res;
      this._panelOptionsService.setPaymentMethods(this.paymentMethodOptions);
    });
  }

  showPreOrderConfirmModal(template: TemplateRef<any>) {
    this.modalConfig.ignoreBackdropClick = true;
    this.modalConfig.class = 'modal-md';
    this.modalRef = this.modalService.show(template, this.modalConfig);
  }

  showPrivacyPolicyModal(template: TemplateRef<any>) {
    this.modalConfig.ignoreBackdropClick = false;
    this.modalConfig.class = 'modal-lg';
    this.modalRef = this.modalService.show(
      PrivacyPolicyComponent,
      this.modalConfig
    );
  }

  navigateTo(url) {
    this.modalRef.hide();
    this.router.navigate([url]);
  }
}
